import React from 'react';

import selectArrow from './assets/select-arrow.svg';

import './styles.css';

const Arrow = () => (
  <div className="Arrow">
    <img src={selectArrow} alt="Select arrow" />
  </div>
);

export default Arrow;
